
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="py-20 bg-piano-black text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6">Start din musikalske rejse i dag</h2>
        <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
          Book en gratis prøvetime og oplev forskellen med professionel klaverundervisning fra Oscar Gilbert.
        </p>
        <Button asChild size="lg" className="bg-piano-gold hover:bg-piano-gold/90 text-white">
          <Link to="/kontakt">Book Gratis Prøvetime</Link>
        </Button>
      </div>
    </section>
  );
};

export default CTA;
